<template>
   <div class="settlement-search">
     <el-form ref="form" :model="form" :inline="true" class="search-form">
       <div class="top-row">
         <!-- 结算周期 -->
         <el-form-item>
           <el-date-picker
             v-model="dateRange.settlementPeriod"
             type="daterange"
             range-separator="-"
             start-placeholder="周期开始日期"
             end-placeholder="周期结束日期"
             value-format="yyyy-MM-dd"
             :clearable="true"
             style="width: 250px"
           />
         </el-form-item>

         <!-- 结算生成日期 -->
         <el-form-item>
           <el-date-picker
             v-model="dateRange.settlementGenerate"
             type="daterange"
             range-separator="-"
             start-placeholder="生成开始日期"
             end-placeholder="生成结束日期"
             value-format="yyyy-MM-dd"
             :clearable="true"
             style="width: 250px"
           />
         </el-form-item>

         <!-- 结算完成日期 -->
         <el-form-item>
           <el-date-picker
             v-model="dateRange.settlementComplete"
             type="daterange"
             range-separator="-"
             start-placeholder="完成开始日期"
             end-placeholder="完成结束日期"
             value-format="yyyy-MM-dd"
             :clearable="true"
             style="width: 250px"
           />
         </el-form-item>
         <!-- 结算名称 -->
         <el-form-item>
           <el-input
             v-model="form.settlementName"
             placeholder="请输入结算名称"
             clearable
             style="width: 240px"
           />
         </el-form-item>

         <!-- 合作方 -->
         <el-form-item>
           <el-select
             v-model="form.partners"
             multiple
             filterable
             collapse-tags
             placeholder="请选择合作方"
             style="width: 240px"
           >
             <el-option
               v-for="item in partnerOptions"
               :key="item.id"
               :label="`(${item.id}) ${item.partnerName}`"
               :value="item.id"
             />
           </el-select>
         </el-form-item>
       </div>

       <div class="bottom-row">

         <!-- 结算状态 -->
         <el-form-item>
           <el-select
             v-model="form.settlementStatus"
             placeholder="请选择结算状态"
             clearable
             style="width: 250px"
           >
             <el-option label="未结算" value="0" />
             <el-option label="结算中" value="1" />
             <el-option label="已结算" value="2" />
           </el-select>
         </el-form-item>

         <!-- 操作按钮 -->
         <el-form-item>
           <el-button v-auth="'SETTLEMENT_REPORT_SEARCH'" type="primary" @click="handleSearch" style="width: 100px">搜索</el-button>
           <el-button v-auth="'SETTLEMENT_REPORT_SETTLEMENT'" type="primary" @click="handleSettlement" style="width: 100px" plain>合作结算</el-button>
           <el-button 
             v-auth="'SETTLEMENT_REPORT_BATCH_SUBMIT'"
             type="warning" 
             @click="handleBatchSubmit"
             :disabled="selectedCount === 0"
             style="width: 100px"
           >
             合并提审
           </el-button>
           <el-button v-auth="'SETTLEMENT_REPORT_EXPORT'" type="success" @click="handleExportList" style="width: 100px">列表导出</el-button>
         </el-form-item>
       </div>
     </el-form>
   </div>
</template>

<script>
import { isArray } from 'ali-oss/lib/common/utils/isArray'
export default {
  name: 'SettlementSearch',
  props: {
    partnerOptions: {
      type: Array,
      default: () => []
    },
    selectedCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      form: {
        settlementName: '',
        partners: [],
        settlementStatus: ''
      },
      dateRange: {
        settlementPeriod: [], // 结算周期
        settlementGenerate: [], // 结算生成日期
        settlementComplete: [] // 结算完成日期
      }
    }
  },
  methods: {
    // 搜索
    handleSearch() {

      this.$emit('search', {
        ...this.form,
        ...this.getDateRangeParams()
      })
    },

    // 获取日期范围参数
    getDateRangeParams() {
      const dateRangeMap = {
        settlementPeriod: ['settlementPeriodStart', 'settlementPeriodEnd'],
        settlementGenerate: ['settlementGenerateStart', 'settlementGenerateEnd'],
        settlementComplete: ['settlementCompleteStart', 'settlementCompleteEnd']
      }
      
      const params = {}
      
      Object.keys(dateRangeMap).forEach(key => {
        const dateRange = this.dateRange[key]
        const [startKey, endKey] = dateRangeMap[key]
        
        if (dateRange && isArray(dateRange) && dateRange.length === 2) {
          params[startKey] = dateRange[0]
          params[endKey] = dateRange[1]
        } else {
          params[startKey] = ''
          params[endKey] = ''
        }
      })
      
      return params
    },

    // 合作结算
    handleSettlement() {
      this.$emit('settlement')
    },

    // 合并提审
    handleBatchSubmit() {
      this.$emit('batchSubmit')
    },

    // 列表导出
    handleExportList() {
      this.$emit('exportList')
    }
  }
}
</script>

<style lang="scss" scoped>
.settlement-search {
  padding: 16px;
  padding-bottom: 0;
  background-color: #fff;
  border-radius: 4px;

  .search-form {

    .top-row {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      justify-content:flex-start;
    }

    .bottom-row {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      justify-content: space-between;
    }
  }
}
</style>
